"use strict";

import Vue from 'vue';
import Vuex from 'vuex';
import budget from './modules/budget/main';
import user from './modules/user/main'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    budget,
    user
  }
});



// WEBPACK FOOTER //
// ./src/store/main.js